import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Table } from "../../../../components/ui/Table";
import { FormatInt } from "../../../../utils/FormatData";
import Icon from "../../../../components/Icon";
import { Alert } from "react-bootstrap";
const StepOne = ({ data = [], summary = null }) => {
  const columns = useMemo(() => {
    if (!data.length) return [];

    const keys = Object.keys(data[0]);

    return keys.map((key) => ({
      Header: key,
      accessor: key,
    }));
  }, [data]);

  const dataSliced = useMemo(() => {
    return data.slice(0, 100);
  }, [data]);

  return (
    <>
      {summary && (
        <div className="flex flex-col gap-2">
          <Alert className="Notice flex items-center gap-2" variant="info">
            <Icon icon="info" className="text-blue-800" />
            Se han cargado solo las primeras 100 filas para vista previa.
          </Alert>
          <div className="text-gray-700 font-semibold text-md px-3 bg-gray-100 rounded-lg py-1 w-max">
            Total de registros: {FormatInt(summary?.summary?.total) || 0}
          </div>
        </div>
      )}
      <Table
        data={dataSliced}
        columns={columns}
        config={{
          pagination: true,
          pageSize: 10,
          perPage: 10,
          footer: true,
        }}
      />
    </>
  );
};

StepOne.propTypes = {
  data: PropTypes.array,
  summary: PropTypes.object,
};
export default StepOne;
